import type { PropsWithChildren } from 'react';
import gtag from '../analytics/gtag';
import Icon from '../generic/Icon';
import type { Breadcrumb, Facet } from '../model/Facets';
import FacetButton from '../search/FacetButton';
import * as style from './ProductGuide.module.css';

interface UnselectedFacetProps {
    facet: Facet;
    isExpanded: boolean;
    toggleExpand(facetCode: string): void;
}

export function UnselectedFacet({ facet, isExpanded, toggleExpand, children }: PropsWithChildren<UnselectedFacetProps>) {
    return (
        <div className={style.expandable}>
            <button aria-expanded={isExpanded} className={style.expandableHeader} onClick={() => toggleExpand(isExpanded ? '' : facet.code)}>
                <span>{facet.name}</span>
                <Icon className="icon-chevron-down" renderWithSpan />
            </button>
            <div className={`facet__${facet.code}`}>{isExpanded && children}</div>
        </div>
    );
}

interface SelectedFacetProps {
    breadcrumb: Breadcrumb;
    removeFacetValue(query: string): Promise<void>;
}

export function SelectedFacet({ breadcrumb, removeFacetValue }: SelectedFacetProps) {
    return (
        <div className={style.expandable}>
            <div className={style.expandableHeader}>
                <span>{breadcrumb.facetName}</span>
                <FacetButton
                    onClick={async () => {
                        gtag('event', 'filter_remove', {
                            filter_type: breadcrumb.facetName,
                            filter_value: breadcrumb.facetValueName,
                        });
                        await removeFacetValue(breadcrumb.removeQuery);
                    }}
                    selected
                    title={breadcrumb.facetValueName}
                />
            </div>
        </div>
    );
}
